<template>
    <TransitionGroup name="fade">
        <ButtonPopover
            v-if="!hasTypeSelected"
            button-text="Add bonus offer"
            buttonClass="btn-base btn-transparent !pl-0"
            :icon="'plus'"
        >
            <template #default="{ closePopover }">
                <ul>
                    <li v-for="offerType in offerTypes" :key="offerType.value">
                        <button
                            type="button"
                            class="w-full p-2 text-sm text-gray-900 dark:text-gray-100 rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors"
                            @click="
                                selectFirstOfferType(
                                    offerType.value,
                                    closePopover
                                )
                            "
                        >
                            {{ offerType.label }}
                        </button>
                    </li>
                </ul>
            </template>
        </ButtonPopover>
        <div v-else class="w-full">
            <BonusOfferForm
                v-for="(offer, index) in bonusOffers"
                :key="index"
                v-model:offer="bonusOffers[index]"
                :index="index"
                :is-last-offer="index === bonusOffers.length - 1"
                :errors="errors"
                :backgroundColor="formBackgroundColor"
                @delete="removeBonusOffer(index)"
                @add-offer="addNewOffer($event)"
            />
        </div>
    </TransitionGroup>
</template>

<script setup>
import { computed } from 'vue';
import ButtonPopover from '@/components/ui/button-popover.vue';
import BonusOfferForm from '@/components/wallet/partials/bonus-offer-form.vue';

const emit = defineEmits(['delete']);

const bonusOffers = defineModel('bonus-offers', {
    type: Array,
});

const props = defineProps({
    errors: Object,
    formBackgroundColor: { type: String, default: 'slate' },
});

const hasTypeSelected = computed(() => {
    // return true;
    return bonusOffers.value?.some((offer) => offer.type);
});

const offerTypes = [
    {
        label: 'Upgrade offer',
        value: 'upgrade',
    },
    {
        label: 'Retention offer',
        value: 'retention',
    },
    {
        label: 'Referral bonus',
        value: 'referral',
    },
    {
        label: 'Other',
        value: 'other',
    },
];

const createDefaultBonusOffer = (type) => ({
    type,
    bonus_amount: null,
    bonus_units: 'points',
    minimum_spend_amount: null,
    minimum_spend_deadline: null,
    received: false,
    date_received: null,
});

const selectFirstOfferType = (type, close) => {
    bonusOffers.value[0].type = type;
    close();
};

const addNewOffer = (type) => {
    const newOffer = createDefaultBonusOffer(type);
    bonusOffers.value.push(newOffer);
};

const removeBonusOffer = (index) => {
    if (bonusOffers.value.length === 1) {
        bonusOffers.value[0] = createDefaultBonusOffer('');
        emit('delete');
    } else {
        bonusOffers.value.splice(index, 1);
    }
};
</script>
